import { HttpClient, HttpHeaders } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { Observable, combineLatest, of } from "rxjs";
import { Config } from "../core/config/api.config";
import { TranslationModuleEnum } from "./translation-modules.enum";
import { licenceKey } from "src/license/license";
import { environment } from "src/environments/environment";
import { delay, map } from "rxjs/operators";

export class CustomTranslateLoader implements TranslateLoader {

  constructor(private http: HttpClient, private moduleNames: TranslationModuleEnum[], private isPublicAPI: boolean = false) { }

  getTranslation(lang: string): Observable<any> {

    let requests: Observable<any>[] = [];
    const headers = new HttpHeaders({
      Authorization: localStorage.getItem("$EPPM$token") ? 'Bearer '+ localStorage.getItem("$EPPM$token") : '',
      "Content-Type": "application/json",
      "Accept-Language": localStorage.getItem("locale"),
      "License-Key": licenceKey.valid,
    });
    let actionEndpoint = Config.Translation.GetUnAuth;
    const mergedTanslationFile = JSON.parse(sessionStorage.getItem("translation_file_mergedTranslations")) || {en:{},ar:{}}

    this.moduleNames.forEach(module => {
      const cachedResoponseEn: any = mergedTanslationFile['en'][TranslationModuleEnum[module]];
      const cachedResoponseAr: any = mergedTanslationFile['ar'][TranslationModuleEnum[module]];
      // if (!!cachedResoponseEn && !!cachedResoponseAr) {
      //   // simulate same api response
      //   requests.push(of({ar: {[TranslationModuleEnum[module]] : cachedResoponseAr},en: {[TranslationModuleEnum[module]] : cachedResoponseEn}}))
      // }
      // else {
        if (!this.isPublicAPI) {
          actionEndpoint = Config.Translation.Get;
        }
        requests.push(this.http.get(
          `${environment.serverUrl}${actionEndpoint}?module=${module}`,
          { headers }
        ))
     // }
    })

    return combineLatest(requests).pipe(delay(1000),map((res) => this.setMergedTrasnlsation(res)))
  }

  setMergedTrasnlsation(res): any {
    // Here we get the "translation_file_mergedTranslations" from localStorage, then push the new translation module file to it that comes from createSingleLoaderModule().
    let mergedTranslationsFile = JSON.parse(
      sessionStorage.getItem("translation_file_mergedTranslations")
    );
    if (mergedTranslationsFile == undefined) {
      mergedTranslationsFile = {
        en: {},
        ar: {}
      }
    }
    this.moduleNames.forEach((m, index) => {      
        const enTranslation = res[index]['en'];
        const arTranslation = res[index]['ar'];
        Object?.keys(enTranslation).forEach(key => {
          mergedTranslationsFile['en'][key] = enTranslation[key];
        })
        Object?.keys(arTranslation).forEach(key => {
          mergedTranslationsFile['ar'][key] = arTranslation[key];
        })
    })

    sessionStorage.setItem("translation_file_mergedTranslations", JSON.stringify(mergedTranslationsFile));
    const savedCurrentLang = localStorage.getItem("locale");
    let currentLang = 'ar';
    if(savedCurrentLang){
      currentLang = savedCurrentLang.includes('en')? 'en': 'ar'
    }
    return mergedTranslationsFile[`${currentLang}`];
  }

  // setTranslation(data, moduleName) {
  //   localStorage.setItem(`translation_file_${moduleName}`, data);

  //   if (moduleName === "mergedTranslations") {
  //     const dataJson = JSON.parse(data);

  //     Object.entries(dataJson).forEach(([key, value]) => {
  //       localStorage.setItem(`translation_file_${key}`, JSON.stringify(value));
  //     });
  //   }
  // }

}
